<script setup>
import {computed} from "vue";
import {VIEWBOX_SIZE} from "@/components/seo-score/visibility-chart/composables/radialChart";

const props = defineProps({
  score: {
    type: Number,
    required: true,
  },
  alignCenter: {
    type: Boolean,
    required: false,
    default: false,
  }
})

const pill = computed(() => {
  if (props.score < 33.5) {
    return {
      text: 'Base Camp',
      textClass: 'tw-fill-danger',
      fillClass: 'tw-fill-danger-100',
      strokeClass: 'tw-stroke-danger',
    };
  }

  if (props.score < 66.5) {
    return {
      text: 'Moving Up',
      textClass: 'tw-fill-info-700',
      fillClass: 'tw-fill-info-100',
      strokeClass: 'tw-stroke-info-700',
    };
  }
  return {
    text: 'Trailblazer',
    textClass: 'tw-fill-success-700',
    fillClass: 'tw-fill-success-100',
    strokeClass: 'tw-stroke-success-700',
  };
});

const translateX = computed(() => props.alignCenter ? (VIEWBOX_SIZE * -0.065) : (VIEWBOX_SIZE * -0.16));
</script>

<template>
  <g :transform="`translate(${translateX}, ${VIEWBOX_SIZE * 0.20})`">
    <rect
      :x="-VIEWBOX_SIZE * 0.085"
      :y="-VIEWBOX_SIZE * 0.045"
      :width="VIEWBOX_SIZE * 0.30"
      :height="VIEWBOX_SIZE * 0.09"
      :rx="VIEWBOX_SIZE * 0.015"
      :class="[pill.fillClass, pill.strokeClass]"
      :stroke-width="VIEWBOX_SIZE * 0.003"
    />

    <text
      :x="VIEWBOX_SIZE * 0.065"
      :y="VIEWBOX_SIZE * 0.004"
      text-anchor="middle"
      dominant-baseline="middle"
      :font-size="VIEWBOX_SIZE * 0.03"
      :class="pill.textClass"
    >
      {{ pill.text }}
    </text>
  </g>
</template>
